import * as React from 'react';

import { ResponsiveSlot } from '../../locations';

export default function ResponsiveLocation() {
	return <ResponsiveSlot />;
}
